import { createAction } from "typesafe-actions";
import type { ExportItem, ExportName } from "../type";

export const setPreDefinedInvalidFields = createAction("@@si/management/common/SET_PREDEFINED_INVALID_FIELDS")<{
    tabName: ExportName;
    invalidFields: ExportItem[];
}>();

export const setCurrentExportTab = createAction("@@si/management/common/SET_CURRENT_EXPORT_TAB")<{
    currentTabName: ExportName;
    previousTabName: ExportName | "";
}>();

export const setCacheToken = createAction("@@si/management/common/SET_CACHE_TOKEN")<string>();

export const setRecordToEnableExport = createAction(
    "@@si/management/common/SET_RECORD_TO_ENABLE_EXPORT",
)<ExportName | null>();

export const unloadInvalidPredefined = createAction("@@si/management/common/UNLOAD_PREDEFINED_INVALID_FIELDS")<void>();
